export default function () {
    const $formElements = $('select, input, textarea');
    const $select = $('.custom-select-input');

    // flaoting labels
    $formElements.on('focus', (e) => {
        const $element = $(e.target);
        const $formField = $element.closest('.form-field');
        $formField.addClass('focus');
    });

    $formElements.on('blur', (e) => {
        const $element = $(e.target);
        const $formField = $element.closest('.form-field');
        $formField.removeClass('focus active');

        if ($element.val()) {
            $formField.addClass('is-filled');
        } else {
            $formField.removeClass('is-filled');
        }
    });

    // toggle arrow animation
    $select.on('click', (e) => {
        const $element = $(e.target);
        const $parent = $element.closest('.custom-select');

        $parent.toggleClass('active');
    });

    $('.form-field-master').on('change', (e) => {
        const $element = $(e.target);
        const $parent = $element.closest('.custom-select');

        if ($element.val() === '320231' || $element.val() === '376075') {
            $parent.siblings('.form-field-slave').fadeIn();
        } else {
            $parent.siblings('.form-field-slave').fadeOut();
        }
    });
}
